<template lang="pug">
    model-form(
        ref='form'
        submit-text='guardar'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submit'
    )
        template( slot='header-actions' )
            model-autocomplete(
                chips
                hide-details
                item-text='structure_name'
                item-value='id'
                label='Seleccionar tipo de contrato'
                single-line              
                solo
                v-bind='autocompleteProps'
                v-model='autocompleteData'
                style='margin: -12px 0 -12px auto; width: 300px;'
            )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import ContractModel from '@/models/HumanResource/HrContract'
    import ContractStructureModel from '@/models/HumanResource/HrContractStructure'
    import ContractFields from '@/views/HumanResource/HrContract/partials/HrContractFieldsUpdate'
    //
    export default {
        name: 'contract-update',
        components: {
            ModelAutocomplete,
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            autocompleteProps() {
                return {
                    model: ContractStructureModel,
                    outline: false,
                }
            },

            /**
             *
             */
            formProps() {
                return {
                    fields: ContractFields,
                    title: this.title,
                }
            },

            /**
             *
             */
            title() {
                return `Contrato #${this.$route.params.id}`
            },
        },
        data() {
            return {
                autocompleteData: {},
                formData: new ContractModel({
                    base_salary: 0,
                    collation: 0,
                    hr_contract_period_id: 0,
                    hr_contract_type_id: 0,
                    mobilization: 0,
                    weekly_hours: 0,
                    selected: [],
                }),
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(ContractModel, error.response.data))
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'contract-list' })
            },

            /**
             * 
             */
            reset() {
                ContractModel.modeler().include('hr_contract_asset_discount.hr_asset_discount').find(this.$route.params.id).then(this.setFormData)
            },

            /**
             *
             */
            setFormData(model) {
                this.formData = model.reset()
            },

            /**
             * 
             */
            submit() {
                this.$refs.form.setWait(true).then(this.toUpdate).then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            success() {
                this.setSuccessSnackbar('Contrato actualizado exitosamente.')
            },

            /**
             *
             */
            toUpdate(model) {
                return model
                    .toUpdate()
                    .save()
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },
        },
        mounted() {
            this.setTitleTopBar('Detalles de contrato')
            this.reset()
        },
        watch: {

            /**
             * 
             */
            autocompleteData(val) {
                this.formData.base_salary = val.base_salary
                this.formData.collation = val.collation
                this.formData.hr_contract_period_id = val.hr_contract_period_id
                this.formData.hr_contract_type_id = val.hr_contract_type_id
                this.formData.mobilization = val.mobilization
                this.formData.weekly_hours = val.weekly_hours
            }
        }
    }
</script>